import { TextField, TextFieldProps } from '@mui/material';
import { useField } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IMaskInput } from 'react-imask';

export interface TextfieldTypes {
    name: string;
    isRRN?: boolean;
    [otherProps: string]: any;
}

interface TextMaskCustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

const TextMaskCustom = React.forwardRef<HTMLInputElement, TextMaskCustomProps>(
    function TextMaskCustom(props, ref) {
        const { onChange, ...other } = props;
        return (
            <IMaskInput
                {...other}
                mask="00.00.00-000.00"
                unmask={true}
                definitions={{
                    '#': /[0-9]/,
                }}
                inputRef={ref}
                onAccept={(value) => {
                    onChange({ target: { name: props.name, value: value } });
                }}
            />
        );
    }
)
const TextfieldWrapper = ({ name, isRRN, placeholder, ...otherProps }: TextfieldTypes) => {
    const [field, meta] = useField(name);
    const { t } = useTranslation();

    const configTextfield: TextFieldProps = {
        ...field,
        ...otherProps,
        fullWidth: true,
        variant: 'outlined',
        inputProps: {
            placeholder: placeholder,
        }
    };

    if (meta && meta.touched && meta.error) {
        configTextfield.error = true;
        configTextfield.helperText = t(meta.error);
    }

    return <TextField {...configTextfield} InputProps={{inputComponent: isRRN ? TextMaskCustom as any : undefined}} />;
};

export default TextfieldWrapper;
